"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XhrRequestsBlocker = void 0;
class XhrRequestsBlocker {
    constructor() {
        this.unblockCalls = null;
        this.blocker = null;
        this.countRequestBlockCalls = 0;
    }
    getBlocker() {
        return this.blocker;
    }
    startBlockingRequests() {
        if (!this.isBlockingRequest()) {
            this.blocker = new Promise(resolve => {
                this.unblockCalls = resolve;
            });
        }
        this.countRequestBlockCalls++;
    }
    finishBlockingRequest() {
        if (this.countRequestBlockCalls > 0) {
            this.countRequestBlockCalls--;
            if (this.countRequestBlockCalls === 0) {
                this.blocker = null;
                if (this.unblockCalls) {
                    this.unblockCalls();
                }
                this.unblockCalls = null;
            }
        }
    }
    isBlockingRequest() {
        return this.unblockCalls ? true : false;
    }
}
exports.XhrRequestsBlocker = XhrRequestsBlocker;
//# sourceMappingURL=xhrRequestsBlocker.js.map